import React from 'react';

import Button from 'shared/ui/Button/Button/Button';
import Plus from 'shared/ui/icons/Plus';

import styles from './PlugCreateButton.module.scss';

interface PlugCreateButtonProps {
    onClick: () => void;
    children: React.ReactNode;
}

const PlugCreateButton: React.FC<PlugCreateButtonProps> = ({onClick, children}) => {
    return (
        <Button
            variant="gradient"
            onClick={onClick}
            className={styles.button}
        >
            <Plus width={45} height={45}/>
            {children}
        </Button>
    );
};

export default PlugCreateButton;
